export enum Types {
  SET_ABANDONED_CART = 'abandoned-cart/SET_ABANDONED_CART',
  CLEAR_ABANDONED_CART = 'abandoned-cart/CLEAR_ABANDONED_CART',
  SET_DISMISSED = 'abandoned-cart/SET_DISMISSED',
  FETCH_ABANDONED_CART = 'abandoned-cart/FETCH_ABANDONED_CART'
}

export interface AbandonedCartAddress {
  street: string[];
  city: string;
  postcode: string;
  region: string;
}

export interface AbandonedCartPartner {
  bp: string;
  name: string;
  address: AbandonedCartAddress;
}

export interface AbandonedCartItem {
  sku: string;
  name: string;
  image: string;
}

export interface AbandonedCartNotifyState {
  notify1: boolean;
  notify2: boolean;
}

export interface AbandonedCartData {
  quoteId: string;
  sold: AbandonedCartPartner;
  ship: AbandonedCartPartner;
  firstItem: AbandonedCartItem;
  quoteCount: number;
  notification: AbandonedCartNotifyState;
}

export interface AbandonedCartState {
  data: AbandonedCartData | null;
  dismissed: boolean;
}
